import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const employeeTransactionAccessService = {
  // ── Module Access (Original Table) ─────────────────────────────────────────
  getAll: async () => {
    return await axios.get(`${domain}/api/AccessTemplate/employee-transaction-access`, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/AccessTemplate/employee-transaction-access/${id}`, payload, { headers });
  },

  // ── Process Manager Access (New Selective Table) ──────────────────────────
  // ADDED: New methods for field-level access control
  getAllProcessorAccess: async () => {
    return await axios.get(`${domain}/api/EmployeeTransactionProcessorAccess`, { headers });
  },

  createProcessorAccess: async (payload) => {
    return await axios.post(`${domain}/api/EmployeeTransactionProcessorAccess`, payload, { headers });
  },

  updateProcessorAccess: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeTransactionProcessorAccess/${id}`, payload, { headers });
  },
};

export default employeeTransactionAccessService;